export class Notification {
  public id: string | any;
  public created_at: string | any;
  public subject: string | any;
  public message: string | any;
  public is_read: boolean | any;
  public sender_avatar: string | any;
  public type: number | any;
  public sender_full_name: string | any;
  public extra_data: any;

  constructor(data: any = {}) {
    this.id = data.id || null;
    this.created_at = (data.created_at as string).substring(0, 10) || null;
    this.subject = data.subject || null;
    this.message = data.message || null;
    this.is_read = data.is_read || null;
    this.sender_avatar = data.sender_avatar || null;
    this.type = data.type;
    this.sender_full_name = data.sender_full_name || null;
    this.extra_data = data.extra_data;
  }

  public get firstName() {
    const splitNames = this.sender_full_name.split(' ');
    return splitNames[1];
  }

  public get secondName() {
    const splitNames = this.sender_full_name.split(' ');
    return splitNames[0];
  }
}
